export const CUSTOM_TEMPLATES_STRING = 'Custom templates';
export const CLIO_TEMPLATES_STRING = 'Clio templates';

export enum SORT_ORDER_ENUM {
  UNSORTED = 0,
  ASCENDING = 1,
  DESCENDING = -1,
}

export const GENERAL_TEMPLATE_FILTER = '__GENERAL__';
